import { generateProductUrl } from '../../utils/slugUtils';

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "The Random Store",
  "image": "https://therandomstores.com/logo512.png",
  "url": "https://therandomstores.com",
  "telephone": "+919717083055",
  "email": "info@therandomstore.com",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "IN",
    "addressLocality": "Aligarh",
    "addressRegion": "Uttar Pradesh",
    "postalCode": "202001",
    "streetAddress": "324/3 Keshav Nagar"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "27.8974",
    "longitude": "78.0880"
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "opens": "09:00",
    "closes": "18:00"
  },
  "priceRange": "₹₹",
  "paymentAccepted": "Cash, Credit Card, Debit Card, UPI",
  "currenciesAccepted": "INR",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "reviewCount": "127"
  }
};

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "The Random Store",
  "url": "https://therandomstores.com",
  "logo": "https://therandomstores.com/logo512.png",
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+919717083055",
    "contactType": "customer service",
    "email": "info@therandomstore.com",
    "areaServed": "IN",
    "availableLanguage": ["en", "hi"]
  },
  "sameAs": [
    "https://www.facebook.com/profile.php?id=61574113310837",
    "https://instagram.com/_the_randomstore_"
  ]
};

export const createProductSchema = (product) => ({
  "@context": "https://schema.org/",
  "@type": "Product",
  "name": product.name,
  "image": product.images || [],
  "description": product.description,
  "sku": product.id,
  "brand": {
    "@type": "Brand",
    "name": "The Random Store"
  },
  "offers": {
    "@type": "Offer",
    "url": `https://therandomstores.com${generateProductUrl(product)}`,
    "priceCurrency": "INR",
    "price": product.salePrice || product.price,
    "availability": product.inStock !== false ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
    "seller": {
      "@type": "Organization",
      "name": "The Random Store"
    }
  },
  ...(product.aggregateRating && {
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": product.aggregateRating.ratingValue,
      "reviewCount": product.aggregateRating.reviewCount
    }
  })
});

export const createBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": `https://therandomstores.com${item.url}`
  }))
});
